import React, {Component, useEffect, useState} from "react";
import {CheckMember} from './fetch.js';
import Autocomplete from '@material-ui/lab/Autocomplete';

import {
    Avatar, Box, Button, Checkbox,
    Container, createMuiTheme,
    CssBaseline,
    FormControlLabel,
    Grid, Hidden, Link,
    makeStyles, Modal,
    TextField,
    Typography
} from "@material-ui/core";
import {Copyright} from "@material-ui/icons";

const theme = createMuiTheme();

/*
let MainContainer = {
    position: 'absolute',
    background: 'white',
    top: '2em',
    left: '2em',
    bottom: '2em',
}
*/

const paper = {
    marginTop: '20px',
    // marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}
const avatar = {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
}
const form = {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
}
const submit = {
    margin: theme.spacing(3, 0, 2),
}

const countryToFlag = (isoCode) => {
    return typeof String.fromCodePoint !== 'undefined'
        ? isoCode
            .toUpperCase()
            .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
        : isoCode;
}

export default class NonMemberOnlineRegistrationForm extends React.PureComponent {

    ModalLabel = {
        fontSize: '1.5rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '1.334',
        letterSpacing: '0em',
        margin: '0',
    }

    ModalLabelSmall = {
        fontSize: '1.2rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '1.334',
        letterSpacing: '0em',
        margin: '0',
    }

    ModalBody = {
        backgroundColor: 'white',
        width: '25vw',
        marginLeft: 'auto',
        marginRight: 'auto',
        left: '0',
        right: '0',
        textAlign: 'center',
        position: 'absolute',
        top: '33%',
        padding: '10px',
    }

    MainContainer = {
        position: 'absolute',
        background: 'white',
        top: '2em',
        left: '2em',
        bottom: '2em',
    }


    constructor(props) {
        super(props);
        debugger;
        this.state = {
            isShowBadAuthModal: false,
            isShowTbSfn: false,
            countries: []
        };

        this.getData('getSfnAllCountryList', {},
            (result) => {
                this.setState(
                    prevState => {
                        const {isShowTbSfn: prevIsShow} = prevState;
                        return {
                            countries: result.data,
                        };
                    },
                    () => {
                        // this.setSomeOtherState();
                    }
                );
            },
            (error) => {
            }
        );

    }

    getData = (actionName, data, successCallback, errorCallback) => {
        CheckMember(
            actionName,
            data,
            (result) => {
                successCallback(result);
            },
            (error) => {
                errorCallback(error);
                debugger;
            });
    }

    badAuthModalClosed(newValue) {
        debugger;
        if(newValue == 'escapeKeyDown' || newValue == 'backdropClick'){

            this.setState(
                prevState => {
                    const {isShowBadAuthModal: prevIsShowBadAuthModal} = prevState;
                    return {
                        isShowBadAuthModal: false,
                    };
                },
                () => {
                    // this.setSomeOtherState();
                }
            );

        }

    }

    tbSfnChanged(newValue) {

        if (newValue == null) {
            return;
        }

        this.setState(
            prevState => {
                const {tbSfnCode: prevIsShow} = prevState;
                return {
                    tbSfnCode: newValue.target.value,
                };
            },
            () => {
                // this.setSomeOtherState();
            }
        );

    }

    countryChanged(newValue) {

        if (newValue == null) {
            return;
        }
        this.getData('checkIfCountryIsSfn', {countryName: newValue.Name},
            (result) => {

                this.setState(
                    prevState => {
                        const {isShowTbSfn: prevIsShow} = prevState;
                        return {
                            isShowTbSfn: result.data,
                        };
                    },
                    () => {
                        // this.setSomeOtherState();
                    }
                );

            },
            (error) => {
            });
    }

    countryTextChanged(newValue) {
        this.setState(
            prevState => {
                const {isShowTbSfn: prevIsShow} = prevState;
                return {
                    isShowTbSfn: false,
                };
            },
            () => {
                // this.setSomeOtherState();
            }
        );

    }

    askUserIfHeWantsToContinueAsNonMember() {

        this.setState(
            prevState => {
                const {isShowBadAuthModal: prevIsShowBadAuthModal} = prevState;
                return {
                    isShowBadAuthModal: true,
                };
            },
            () => {
                // this.setSomeOtherState();
            }
        );

        // var r = window.confirm('Incorrect SFN number do you want to continue as non-member?');
        // if (r == true) {
        //     this.redirectToUrl('https://kenes.eventsair.com/KenesSiteRedirect/fens22/appnonmemberredirect/contactpost/data');
        // }

    }

    closeBadAuthModal(element) {
        this.setState(
            prevState => {
                const {isShowBadAuthModal: prevIsShowBadAuthModal} = prevState;
                return {
                    isShowBadAuthModal: false,
                };
            },
            () => {
                // this.setSomeOtherState();
            }
        );

    }

    redirectToNoneMemberClicked(element) {
        this.redirectToUrl('https://kenes.eventsair.com/fens22/fensnmv22');
    }

    redirectToUrl(url) {
        const memberDetailsForm = document.getElementById('memberDetailsForm');
        memberDetailsForm.setAttribute('action', url);
        memberDetailsForm.submit();
    }

    submitRegistration(newValue) {
        newValue.preventDefault();
        if (this.state.tbSfnCode == null || this.state.tbSfnCode == '') {
            this.redirectToUrl('https://kenes.eventsair.com/fens22/fensnmv22');
        } else {
            this.getData('checkFensNonMember', {customerId: this.state.tbSfnCode},
                (result) => {
                    debugger;
                    if (result.data.FensResponse.SuccessFlag == 'True') {
                        this.redirectToUrl('https://kenes.eventsair.com/KenesSiteRedirect/fens22/sfn-virtual-redirect/contactpost/data');
                    } else {
                        this.askUserIfHeWantsToContinueAsNonMember();
                    }
                },
                (error) => {
                    this.askUserIfHeWantsToContinueAsNonMember();
                }
            );
        }
    }

    onWindowResize = () => {
        if (window.innerWidth < 500 || window.innerHeight < 500) {
            this.MainContainer = {
                position: 'unset',
                background: 'white',
                top: '2em',
                left: '2em',
                bottom: '2em',
            }
            this.ModalBody = {
                backgroundColor: 'white',
                width: '77vw',
                marginLeft: 'auto',
                marginRight: 'auto',
                left: '0',
                right: '0',
                textAlign: 'center',
                position: 'absolute',
                top: '33%',
                padding: '10px',
            }
        }
    }

    render() {

        window.addEventListener( 'resize', this.onWindowResize, false );

        if (window.innerWidth < 500 || window.innerHeight < 500) {
            this.MainContainer = {
                position: 'unset',
                background: 'white',
                top: '2em',
                left: '2em',
                bottom: '2em',
            }
            this.ModalBody = {
                backgroundColor: 'white',
                width: '77vw',
                marginLeft: 'auto',
                marginRight: 'auto',
                left: '0',
                right: '0',
                textAlign: 'center',
                position: 'absolute',
                top: '33%',
                padding: '10px',
            }
        }

        return (
            <Container style={this.MainContainer} component="main" maxWidth="xs">
                <CssBaseline/>
                <img style={{width: '50%', marginTop: '10px'}}
                     src={"https://forum.fens.org/wp-content/uploads/sites/129/2018/07/logo-white-bg-new1.png"}/>
                <div style={paper}>
                    <Avatar style={avatar}>
                        {/*<LockOutlinedIcon/>*/}
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Register
                    </Typography>
                    <form id="memberDetailsForm" method="post" style={form}
                          onSubmit={(element) => {
                              this.submitRegistration(element);
                          }}
                    >
                        <input type="hidden" name="tle" value=""/>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    id="firstName"
                                    name="giv"
                                    autoComplete="fname"
                                    variant="outlined"
                                    required
                                    fullWidth
                                    label="First Name"
                                    autoFocus
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    id="lastName"
                                    name="sur"
                                    variant="outlined"
                                    required
                                    fullWidth
                                    label="Last Name"
                                    autoComplete="lname"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="email"
                                    name="e_mail"
                                    variant="outlined"
                                    required
                                    fullWidth
                                    label="Email Address"
                                    autoComplete="email"
                                />
                            </Grid>
                            <Grid item xs={12}>

                                <Autocomplete
                                    id="country-select-demo"
                                    style={{width: 300}}
                                    options={this.state.countries}
                                    onChange={(event, newValue) => {
                                        this.countryChanged(newValue);
                                    }}
                                    onInputChange={(event, newValue) => {
                                        this.countryTextChanged(newValue);
                                    }}
                                    autoHighlight
                                    getOptionLabel={(option) => option.Name}
                                    renderOption={(option) => (
                                        <React.Fragment>
                                            {/*<span>{countryToFlag(option.Name)}</span>*/}
                                            {option.Name}
                                        </React.Fragment>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            name="country"
                                            required
                                            label="Choose a country"
                                            variant="outlined"
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: 'new-password', // disable autocomplete and autofill
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            {this.state.isShowTbSfn == true &&
                            <Grid item xs={12}>
                                <TextField
                                    onChange={(element) => {
                                        this.tbSfnChanged(element);
                                    }}
                                    variant="outlined"
                                    required
                                    fullWidth
                                    id="snfCode"
                                    label="Sfn Code"
                                    helperText="Please provide your SfN number. If none put '0'"
                                    name="Sfn Code"
                                    autoComplete="Sfn Code"
                                />
                                {/*<TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="password"
                                    label="Password"
                                    type="password"
                                    id="password"
                                    autoComplete="current-password"
                                />*/}
                            </Grid>}
                            {/*<Grid item xs={12}>
                                <FormControlLabel
                                    control={<Checkbox value="allowExtraEmails" color="primary"/>}
                                    label="I want to receive inspiration, marketing promotions and updates via email."
                                />
                            </Grid>*/}
                        </Grid>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            style={submit}
                        >
                            Submit
                        </Button>
                        {/*<Grid container justify="flex-end">
                            <Grid item>
                                <Link href="#" variant="body2">
                                    Already have an account? Sign in
                                </Link>
                            </Grid>
                        </Grid>*/}
                    </form>
                </div>
                <Modal
                    open={this.state.isShowBadAuthModal}
                    onClose={(event, newValue) => {
                        this.badAuthModalClosed(newValue);
                    }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    <div style={this.ModalBody}>
                        {/*<img style={{width: '50%', marginTop: '10px'}}
                             src={"https://forum.fens.org/wp-content/uploads/sites/129/2018/07/logo-white-bg-new1.png"}/>*/}
                        <table style={{width: '100%',}}>
                            <tr>
                                <td colspan={2}>
                                    <p style={this.ModalLabel}>Incorrect SFN number</p>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <br/>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <p style={this.ModalLabelSmall}>Do you want to continue as non-member?</p>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <br/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={(element) => {
                                            this.redirectToNoneMemberClicked(element);
                                        }}
                                    >
                                        Yes
                                    </Button>
                                </td>
                                <td>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={(element) => {
                                            this.closeBadAuthModal(element);
                                        }}
                                    >
                                        No
                                    </Button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Modal>
                {/*<Box mt={5}>
                    <Copyright/>
                </Box>*/}
            </Container>
        );
    }



}

// export default RegistrationForm;
